const constants = {
  interface: {
    notificationsInterval: 15000,
    delayCallActionTime: 200,
    entityListPageSize: 25,
    notificationsPageSize: 10,
    supervisorRevisionsPageSize: 7,
    popupPageSize: 10,
    calculationInstancesDetailPageSize: 5,
    emailHistoryPageSize: 4,
    metricDataListPageSize: 25,
    assignListPageSize: 100,
    fullListPageSize: 10000,
    loadMetricObjectGroupSelectOptionsNumber: 5,
    maxSelectedTagsFilter: 3,
    tostrOptions: {
      closeButton: true,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: 'toast-bottom-left',
      preventDuplicates: false,
      showDuration: '300',
      hideDuration: '1000',
      timeOut: '5000',
      extendedTimeOut: '1000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut',
    },
    tostrOptionsShortTimeout: '2000',
    inputs: {
      styleType: {
        OUTLINED: "outlined",
        STANDARD: "standard"
      },
      type: {
        TEXT: "text",
        PASSWORD: "password",
        EMAIL: "email",
        CHECKBOX: "checkbox"
      }
    },
    popup: {
      transitionTime: 500,
      types: {
        CENTERED: "centered",
        LATERAL: "lateral"
      }
    },
    toolTip: {
      formulaDraggable: "formulaDraggable",
      formItemHelp: "formItemHelp",
      formSectionHelp: "formSectionHelp",
    }
  },
  app: {
    menuKeys: {
      HOME: "HOME",
      SUPERVISOR_REVISION_PANEL: "SUPERVISOR_REVISION_PANEL",
      ADMIN_USERS: "ADMIN_USERS",
      ADMIN_CALCULATION_UNIT_PARENT: "ADMIN_CALCULATION_UNIT_PARENT",
      ADMIN_CALCULATION_UNIT: "ADMIN_CALCULATION_UNIT",
      ADMIN_GROUP: "ADMIN_GROUP",
      ADMIN_ASSIGN_GROUP: "ADMIN_ASSIGN_GROUP",
      ADMIN_ASSIGN_POLYNOMIAL_GROUP: "ADMIN_ASSIGN_POLYNOMIAL_GROUP",
      ADMIN_ASSIGN_POLYNOMIAL_CALCULATION_UNIT: "ADMIN_ASSIGN_POLYNOMIAL_CALCULATION_UNIT",
      ADMIN_CONFIG: "ADMIN_CONFIG",
      ADMIN_CONFIG_DIMENSION: "ADMIN_CONFIG_DIMENSION",
      ADMIN_CONFIG_METRIC: "ADMIN_CONFIG_METRIC",
      ADMIN_CONFIG_VIRTUAL_METRIC: "ADMIN_CONFIG_VIRTUAL_METRIC",
      ADMIN_CONFIG_METRIC_DATA: "ADMIN_CONFIG_METRIC_DATA",
      ADMIN_CONFIG_METRICS_GROUP: "ADMIN_CONFIG_METRICS_GROUP",
      ADMIN_CONFIG_POLYNOMIAL: "ADMIN_CONFIG_POLYNOMIAL",
      EXPORT_CONFIGURATIONS_ADMIN: "EXPORT_CONFIGURATIONS_ADMIN",
      ADMIN_SUPERVISORS_REVISIONS_PANEL: "ADMIN_SUPERVISORS_REVISIONS_PANEL",
      ENDPOINTS_CONNECTORS: "ENDPOINT_CONNECTORS",
      ENDPOINTS_CONNECTORS_PANEL: "ENDPOINT_CONNECTORS_PANEL",
      ENDPOINTS_CONNECTORS_ADMIN: "ENDPOINTS_CONNECTORS_ADMIN",
      ENDPOINTS_CONNECTORS_VARIABLES_ADMIN: "ENDPOINTS_CONNECTORS_VARIABLES_ADMIN",
      CALCULATIONS: "CALCULATIONS",
      CALCULATIONS_ACTUAL_PERIOD: "CALCULATIONS_ACTUAL_PERIOD",
      CALCULATIONS_CLOSED_PERIODS: "CALCULATIONS_CLOSED_PERIODS",
      CALCULATIONS_HISTORY: "CALCULATIONS_HISTORY",
      PRE_CALCULATIONS_HISTORY: "PRE_CALCULATIONS_HISTORY",
      ADMIN_DATA: "ADMIN_DATA",
      REPORT_TEMPLATES: "REPORT_TEMPLATES",
	    ADMIN_REPORT_TEMPLATES: "ADMIN_REPORT_TEMPLATES",
	    ADMIN_ASSIGN_REPORT_TEMPLATE_GROUP: "ADMIN_ASSIGN_REPORT_TEMPLATE_GROUP",
      ADMIN_ASSIGN_REPORT_TEMPLATE_CALCULATION_UNIT: "ADMIN_ASSIGN_REPORT_TEMPLATE_CALCULATION_UNIT",
	    ADMIN_BI_TEMPLATES: "ADMIN_BI_TEMPLATES",
      BI_REPORTS: "BI_REPORTS",
      BI_CALCULATIONS_SUMMARY: "BI_CALCULATIONS_SUMMARY",
      SESSION: "SESSION",
      CHANGE_PASSWORD: "CHANGE_PASSWORD",
      TOUR: "TOUR",
      SHOW_TOUR: "SHOW_TOUR",
      UPDATE_CUSTOMER: "UPDATE_CUSTOMER",
      CALENDAR: "CALENDAR",
      NOTIFICATIONS: "NOTIFICATIONS",
      SESSION_LOGOUT: "SESSION_LOGOUT"
    },
    routes: {
      login: "/login",
      resetPassword: "/reset_password/:resetToken",
      confirmAccount: "/confirm_account/:confirmToken",
      home: "/",
      calendar: "/calendar",
      userAdmin: "/user_admin",
      calculationUnitAdmin: "/calculation_unit_admin",
      groupAdmin: "/group_admin",
      assignGroupAdmin: "/assign_group_admin",
      assignPolynomialGroupAdmin: "/assign_polynomial_group_admin",
      assignPolynomialCalculationUnitAdmin: "/assign_polynomial_calculation_unit_admin",
      dimensionAdmin: "/dimension_admin",
      polynomialAdmin: "/polynomial_admin",
      metricAdmin: "/metric_admin",
      virtualMetricAdmin:"/virtual_metric_admin",
      endpointsConnectorsPanel: "/endpoints_connectors_panel",
      endpointsConnectorsAdmin: "/endpoints_connectors_admin",
      endpointsConnectorsVariablesAdmin: "/endpoints_connectors_variables_admin",
      metricsGroupAdmin: "/metrics_group_admin",
      metricDataAdmin: "/metric_data_admin",
      calculationsActualPeriod: "/calculations_actual_period",
      calculationsClosedPeriods: "/calculations_closed_periods",
      calculationsHistory: "/calculations_history",
      preCalculationsHistory: "/pre_calculations_history",
      reportTemplateAdmin: "/report_template_admin",
      assignReportTemplateGroupAdmin: "/assign_report_template_group_admin",
      assignReportTemplateCalculationUnitAdmin: "/assign_report_template_calculation_unit_admin",
      biTemplateAdmin: "/bi_template_admin",
      biCalculationsSummary: "/bi_calculations_summary",
      supervisorsRevisionsPanelAdmin: "/supervisors_revisions_panel_admin",
      supervisorRevisionPanel: "/supervisor_revision_panel",
      exportConfigurationsAdmin: "/export_configurations_admin",
    },
    userRoles: {
      USER: "user",
      ADMIN: "admin",
      PERIOD_ADMIN: "period_admin",
      SUPERVISOR: "supervisor",
    },
  },
  crudGenerator: {
    dataTypes: {
      TEXT: "TEXT",
      DATE: "DATE",
      TIME: "TIME",
      DATETIME: "DATETIME",
      BOOLEAN: "BOOLEAN",
      NUMBER: "NUMBER",
      NUMBER_ALL_DECIMALS: "NUMBER_ALL_DECIMALS"
    },
    orderTypes: {
      ASC: "asc",
      DESC: "desc"
    }
  },
  style: {
    alignTypes: {
      LEFT: "LEFT",
      RIGHT: "RIGHT",
      CENTER: "CENTER"
    }
  },
  assign: {
    groupBy: {
      GROUP: 'GROUP',
      CALCULATION_UNIT: 'CALCULATION_UNIT',
      POLYNOMIAL: 'POLYNOMIAL',
      REPORT_TEMPLATE: 'REPORT_TEMPLATE'
    }
  },
  textFiltersDataTypes: {
    DATE: "date",
    DATETIME: "datetime",  
  },
  selectKeys: {
    supervisor: {
      modelsFilters: {
        ALL: "all",
        //ALL_NOT_APPROVED: "all_not_approved",
        //ALL_NOT_ANSWERED: "all_not_answered",
        ALL_EXCEPT: "all_except",
        ONLY: "only",
      },
    },
    userThemes:{
      lightTheme: "light_theme",
      darkTheme: "dark_theme",
    },
    userColors: {
      blueTheme: "blue_theme",
      greenTheme: "green_theme",
      redTheme: "red_theme",
      userTheme: "user_theme"
    },
    calculationUnit: {
      importMethod: {
        UNIQUE_PICTURE: "unique_picture",
        DEFAULT: "default"
      },
      globalLabelContext: {
        EMPLOYEE: "employee",
      }
    },
    dimension: {
      dataType: {
        STRING: "string",
        NUMBER: "number",
        PERCENTAGE: "percentage",
        BOOLEAN: "boolean",
        DATE: "date",
        DATETIME: "datetime",
        TIME: "time",
      },
      domain_input_source: {
        DEF_USER: "def_user",
        FREE: "free"
      }
    },
    metric: {
      dataType: {
        STRING: "string",
        NUMBER: "number",
        PERCENTAGE: "percentage",
        BOOLEAN: "boolean",
        DATE: "date", 
        DATETIME: "datetime",
        TIME: "time",
        OBJECT: "object",
        DIMENSION: "dimension",        
      },
      metricType: {
        STANDARD: "standard",
        DYNAMIC: "dynamic",
      },
      objectDefinitionDataType: {
        STRING: "string",
        NUMBER: "number",
        PERCENTAGE: "percentage",
        BOOLEAN: "boolean",
        DATE: "date", 
        DATETIME: "datetime",
        TIME: "time",
        DIMENSION: "dimension"
      },
    },
    virtualMetric: {
      joinType: {
        INNER: "inner",
        LEFT: "left",
        RIGHT: "right",
        FULL: "full"
      },
      joinColumnsTransformations: {
        system_dimension_validation_calculation_unit: "system_dimension_validation_calculation_unit",
        system_dimension_validation_group: "system_dimension_validation_group",
        system_dimension_validation_period: "system_dimension_validation_period",
      },
    },
    polynomial: {
      formulaType: {
        FORMULA: "formula",
        TABLE: "table"
      }
    },
    endpoint: {
      endpoint_method: {
        _get: "_get",
        _post: "_post",
        _put: "_put",
        _patch: "_patch",
        _delete: "_delete",
      },
      connector_schedule: {
        recurrent: "recurrent",
        period_date: "period_date",
      },
      connector_schedule_period_date: {
        start_date: "start_date",
        end_date: "end_date",
        query_date: "query_date",
      },
      endpoint_parameters: {
        location: {
          body: "body",
          url: "url",
          url_path: "url_path",
          url_concat_value: "url_concat_value"
        },
        value_type: {
          fixed: "fixed",
          page: "page",
          date: "date",
          formula: "formula",
          file: "file",
          filename: "filename",
          calculation_data: "calculation_data",
        },
        date_value: {
          today: "today",
          start_date: "start_date",
          end_date: "end_date",
          query_date: "query_date",
        },
        calculation_data_value: {
          calculation_unit_code: "calculation_unit_code",
          model_code: "model_code",
          value: "value",
          detail_value: "detail_value",
          detail_goal: "detail_goal",
          reprocess_tag: "reprocess_tag",
          association_code: "association_code",
        }
      },
      endpoint_connector_mapping_filter: {
        field_value_type: {
          integer: "integer",
          float: "float",
          string: "string",
          date: "date",
        },
        value_type: {
          fixed: "fixed",
          date: "date",
          //formula: "formula",
          null: "null"
        },
        date_value: {
          today: "today",
          start_date: "start_date",
          end_date: "end_date",
          query_date: "query_date",
        },
        logic_comparator_operator: {
          equal: "=",
          not_equal: "<>",
          greater_equal: ">=",
          lower_equal: "<=",
          greater: ">",
          lower: "<",
        },
        logic_operator: {
          and: "and",
          or: "or",
        },
        mapping_column_pivot_options: {
          pivot: "pivot",
          value: "value",
        }
      },
      endpoint_connector_type: {
        login_endpoint_type: "login_endpoint_type",
        calculation_units_endpoint_type: "calculation_units_endpoint_type",
        calculation_unit_group_or_model_associations_endpoint_type: "calculation_unit_group_or_model_associations_endpoint_type",
        metric_values_endpoint_type: "metric_values_endpoint_type",
        output_export_calculation_units_calculations_endpoint_type: "output_export_calculation_units_calculations_endpoint_type",
        output_export_calculation_units_reports_endpoint_type: "output_export_calculation_units_reports_endpoint_type",
      },
      reprocess_criteria: {
        only_reprocess: "only_reprocess",
        all_full_calculations: "all_full_calculations"
      },
      connector_calcualtion_unit_group_model_association_type: {
        model_calculation_unit: "model_calculation_unit",
        group_calculation_unit: "group_calculation_unit",
      },
      connector_cu_group_model_association_code_selector: {
        code: "code",
        name: "name",
      },

    },
    reportTemplate: {
      position: {
        LEFT: "left",
        RIGHT: "right"
      },
      format: {
        MONEY: "$",
        PERCENTAGE: "%",
        NUMBER: "#"
      },
      page_layout: {
        PORTRAIT: "portrait",
        LANDSCAPE: "landscape"
      }
    },
    formulaEditor: {
      formulaParamTypes: {
        EMPTY: "empty",
        ALL: "all",
        FREE: "free",
        STRING: "string",
        METRIC_VALUE: "metric_value",
        CONTEXT_DIMENSION: "context_dimension"
      },
      polynomialParamTypes: {
        FREE: "free",
        STRING: "string",
        CONTEXT_DIMENSION: "context_dimension"
      },
      polynomialTableParamTypes: {
        FREE: "free",
        STRING: "string",
        CONTEXT_DIMENSION: "context_dimension"
      },
      metricParamTypes: {
        EMPTY: "empty",
        ALL: "all",
        FREE: "free",
        STRING: "string",
        CONTEXT_DIMENSION: "context_dimension"
      },
      calculationMetricParamTypes: {
        ALL: "all",
        FREE: "free",
        STRING: "string",
        CONTEXT_DIMENSION: "context_dimension"
      },
      metricValueParamTypes: {
        EMPTY: "empty",
        FREE: "free",
        STRING: "string",
        CONTEXT_DIMENSION: "context_dimension"
      },
      inMetricParamTypes: {
        FREE: "free",
        STRING: "string",
        CONTEXT_DIMENSION: "context_dimension"
      },
      periodParamExtraType: {
        HISTORIC_PERIODS: "historic_periods",        
      },
      //by now only used for calculation units
      systemDimensionParamTypes: {
        EMPTY: "empty",
        ALL: "all",
        ALL_ACTIVE: "all_active",
        FREE: "free",
        STRING: "string",
        CONTEXT_DIMENSION: "context_dimension",
      },
      //by now only used for calculation units
      systemDimensionCalculationParamTypes: {
        ALL: "all",
        ALL_ACTIVE: "all_active",
        FREE: "free",
        STRING: "string",
        CONTEXT_DIMENSION: "context_dimension",
      },
      loadMetricParamTypes: {
        EMPTY: "empty",
        FREE: "free",
        STRING: "string",
        CONTEXT_DIMENSION: "context_dimension"
      },
      metricReducerTypes: {
        COUNT:"COUNT",
        MAX:"MAX",
        MIN:"MIN",
        AVERAGE:"AVERAGE",
        SUM:"SUM",
        UNIQUE:"UNIQUE"
      },
      negationOptions: {
        negation: "true"
      },
      isSpecialLogicFunctionOptions: {
        is_function: "true"
      },
      optionsBoolean: {
        YES: "true",
        NO: "false"
      },
      optionsBooleanOnlyYes: {
        YES: "true"
      },
      errorTypes: {
        DIV0: "DIV0",
        NODATA: "NODATA",
        INVALIDTABLEVALUE: "INVALIDTABLEVALUE"
      },
      roundTypes: {
        UP: "UP",
        DOWN: "DOWN"
      },
      logicalComparators: {
        equal: "=",
        notEqual: "<>",
        greaterEqual: ">=",
        lowerEqual: "<=",
        greater: ">",
        lower: "<",
        oneterm: "oneterm"
      },
      dimensionLogicalComparators: {
        equal: "=",
        notEqual: "<>",
        greaterEqual: ">=",
        lowerEqual: "<=",
        greater: ">",
        lower: "<",
      },
      tableReturnTypes: {
        NUMBER: "NUMBER",
        STRING: "STRING"
      },      
      tableColumnTypes: {
        NUMBER: "NUMBER",
        RANGE: "RANGE",
        STRING: "STRING",
        VALIDATE_BY_DIMENSION: "VALIDATE_BY_DIMENSION"
      },      
      extractDateTypes: {
        DAY: "day",
        MONTH: "month",
        YEAR: "year",
        HOUR: "hour",
        MINUTE: "minute",
        SECOND: "second"
      },      
      calendarDayTypes: {
        ALL: "all",
        LABORAL: "laboral",
        NON_LABORAL: "non_laboral"
      },
      reduceXTypes: {
        MAX:"MAX",
        MIN:"MIN",
        AVERAGE:"AVERAGE",
        SUM:"SUM",
      },
      infoXTypes: {
        INDEX:"INDEX",
        LENGTH:"LENGTH",
        LASTVALUE:"LASTVALUE",
        FIRST:"FIRST",
        LAST:"LAST",
      },
      reduceXMetricOrderTypes: {
        columnTypes: {
          DIMENSION: "DIMENSION",
          VALUE: "VALUE",
        },
      },
      optionsToSetDimensionTypes: {
        EMPTY: "empty",
        FREE: "free",
        HISTORIC_PERIODS: "historic_periods",
      },
      dimensionRangeOperatorTypes: {
        AND: "AND",
        OR: "OR",
      }
    },
    reportMetricsDetail: {
      onlyValueSelect: {
        VALUE: "VALUE"
      },
      columnTypes: {
        DIMENSION: "DIMENSION",
        VALUE: "VALUE",
        VIRTUAL: "VIRTUAL"
      },
      columnTypesMetricCalculation: {
        DIMENSION: "DIMENSION",
        VALUE: "VALUE"
      },
      reducerOptions: {
        COUNT:"COUNT",
        MAX:"MAX",
        MIN:"MIN",
        AVERAGE:"AVERAGE",
        SUM:"SUM",
      },
      directionOptions: {
        ASC:"ASC",        
        DESC:"DESC"
      },
      transformationOptions: {
        YEAR: "YEAR",
        YEAR_MONTH: "YEAR_MONTH",
        YEAR_MONTH_DAY : "YEAR_MONTH_DAY"
      }
    },
    metricsGroupEtl: {
      etlTransformations: {
        COLUMN_MAPPING: "COLUMN_MAPPING",
        REPLACE: "REPLACE",
        // CHILEANRUTVALIDATIONCODE: "CHILEANRUTVALIDATIONCODE",
        UNIXTIMETODATETIME: "UNIXTIMETODATETIME",
        CHILEANRUTFORMAT: "CHILEANRUTFORMAT",
        EXTRACT: "EXTRACT",
        MAPCOLUMNWITHHASHMETRIC: "MAPCOLUMNWITHHASHMETRIC",
        UPPERCASE: "UPPERCASE",
        LOWERCASE: "LOWERCASE",
        COLUMN_PIVOT_MAPPING: "COLUMN_PIVOT_MAPPING",
      },
      extractIntervalSelectorType: {
        INDEXOF: "INDEXOF",
        INDEX: "INDEX",
      },
      mappingColumnPivotOptions: {
        PIVOT: "PIVOT",
        VALUE: "VALUE",
      }
    },
    entityUseQuery: {
      entityTypes: {
        DIMENSION: "Dimension",
        METRIC: "Metric",
        POLYNOMIAL: "Polynomial"
      }
    },
    optionsBoolean: {
      YES: "true",
      NO: "false"
    },
    calendar: {
      repetitionOptions: {
        WEEKS: "weeks",
        YEARS: "years"
      }
    },
    periodAdmin: {
      allModelsSelectKey: "all",
      calculationDebugModeTypes:
      {
        NO_DEBUG: "no_debug",
        NORMAL_DEBUG: "normal_debug",
        REDUCEX_DEBUG: "reducex_debug"
      },
      calculationDebugModeSelect:
      {
        NORMAL_DEBUG: "normal_debug",
        REDUCEX_DEBUG: "reducex_debug"
      },
    },
    exportConfigurationsAdmin:{
      groupsFilter: {
        ALL: "all",
        ALL_EXCEPT: "all_except",
        ONLY: "only",
      },
      calculationUnitsFilter: {
        ALL: "all",
        ALL_EXCEPT: "all_except",
        ONLY: "only",
      },
      metricGroupsDataFilter: {
        EMPTY: "empty",
        ALL: "all",
        ALL_EXCEPT: "all_except",
        ONLY: "only",
      },
      metricsDataFilter: {
        EMPTY: "empty",
        ALL: "all",
        ALL_EXCEPT: "all_except",
        ONLY: "only",
      },
      reportsDataFilter: {
        EMPTY: "empty",
        ALL: "all",
      },
      modelsDataFilter: {
        EMPTY: "empty",
        ALL: "all",
        ALL_EXCEPT: "all_except",
        ONLY: "only",
      },
      periodsExcelSeparation: {
        SEPARATED_FILES: "separated_files",
        SEPARATED_SHEETS: "separated_sheets",
        // SAME_SHEET: "same_sheet",
      },
      reprocessCriteria: {
        ONLY_REPROCESS: "only_reprocess",
        ALL_FULL_CALCULATIONS: "all_full_calculations",
      },
      periodsCriteria: {
        CURRENT_PERIOD: "current_period",
        ONLY: "only",
        ALL: "all",
        ALL_EXCEPT: "all_except",
      }
    }
  },
  systemDimensionsIdentifiers: {
    group: "Group",
    calculationUnit: "CalculationUnit",
    period: "Period"
  },
  notifications: {
    FAILURE_STATE: "failure",
    SUCCESS_WITH_ERRORS: "success_with_errors",
    SUCCESS_STATE: "success",
    DATA_DELETED_STATE: "data_deleted",
    INVALID_HEURISTIC_STATE: "invalid_heuristic",
    VIEWED_STATE: "viewed",
    CALCULATION_TYPE: "calculation",
    METRIC_IMPORT_TYPE: "metric_import",
    GENERATE_VIRTUAL_METRICS_TYPE: "generate_virtual_metrics",
    GENERATE_REPORT_FILES_TYPE: "generate_report_files",
    SEND_REPORT_FILES_MAILS_TYPE: "send_report_files_mails",
    EXPORT_REPORT_FILES_ENDPOINT_CONNECTOR_TYPE: "export_report_files_endpoint_connector",
    EXPORT_CALCULATIONS_ENDPOINT_CONNECTOR_TYPE: "export_calculations_endpoint_connector",
    PROCESSING_STATE: "processing",
    PROCESSING_STOP_PROCESS_STATE: "processing_stop_process",
    STOPPED_STATE: "stopped"
  },
  calculationFilters: {
    calculationUnitFilter: {
      ALL: "all",
      ALL_EXCEPT: "all_except",
      ONLY: "only",
    },
    dimensionFilter: {
      ALL: "all",
      ALL_EXCEPT: "all_except",
      ONLY: "only",      
    }
  },
  metricAdmin: {
    metricType: {
      STANDARD: "standard",
      VIRTUAL: "virtual",
      DYNAMIC: "dynamic",
    },
  },
  metricGroups: {
    CUSTOM_METRICS: "custom_metrics"
  },  
  supervisorsAdmin: {
    revisionStatus: {
      APPROVED: "approved",
      REJECTED: "rejected",
      NOT_REVIEWED: "not_reviewed",
      INACTIVE: "inactive"
    },
    revisionStatusFilter: {
      APPROVED: "approved",
      REJECTED: "rejected",
      NOT_REVIEWED: "not_reviewed"
    },
    modelRevisionStatus: {
      APPROVED: "approved",
      REJECTED: "rejected",
      INCOMPLETE: "incomplete",
      NOT_GENERATED: "not_generated"
    },
    revisionHistoryActionTypes: {
      EMAIL_SENT: "email_sent",
      GENERATION: "generation",
      REVISION_STATE_CHANGE: "revision_state_change"
    }
  },
  metricDataAdmin: {
    exportLimit: 5000,
    systemDefect: "SYSTEM_DEFECT",
    tableResize: {
      delay: 320, // cant be lower than 300 because css effects
      minSize: 125,
      headerActionsSize: 72,
    }
  },
  calculationsHistory: {
    exportLimit: 5000    
  },
  endpointConnectorPanel: {    
    endpoint_connector_processing_states: {
      SUCCESS: "success",
      SUCCESS_WITH_ERRORS: "success_with_errors",
      PENDING: "pending",
      PROCESSING: "processing",
      FAILURE: "failure"
    }
  },
  formulaEditor: {
    metricBehaviour:{
      ITERABLE_METRIC: "iterable_metric",
      LOADABLE_METRIC: "loadable_metric",
    },
    markCode: "MARK",
    virtualCalculationMetricBlockedDimensions: 2,
    virtualCalculationMetricPivotPosition: 1,
    dataTypesTextBox: {
      ID_CODE: "id_code"
    },
    objectTypes: {
      polynomial: "Polynomial",
      metric: "Metric",
      dimension: "Dimension",
      function: "Function"
    },
    otherObjectTypes: {
      logical: "Logical",
      logicalDimension: "LogicalDimension",
    },
    functionParamsTypes: {
      formula: "FORMULA",
      logicalFormula: "LOGICAL_FORMULA",
      metric: "METRIC",
      metricsList: "METRICS_LIST",
      metricDimensionsOrValueList: "METRIC_DIMENSIONS_OR_VALUE_LIST",
      metricObjectAttributesList: "METRIC_OBJECT_ATTRIBUTES_LIST",
      string: "STRING",
      optionsToSetDimension: "OPTIONS_TO_SET_DIMENSION",
      logicalDimensionFormula: "LOGICAL_DIMENSION_FORMULA",
    },
    formulaTypes: {
      DEFAULT: "DEFAULT",
      METRIC: "METRIC",
      LABEL: "LABEL"
    },
    entities: {
      group: "group",
      period: "period",
      calculationUnit: "calculationUnit"
    },
    entitiesAttributes: {
      group: {
        name: "name"
      },
      period: {
        name: "name",
        start_date: "start_date",
        end_date: "end_date"
      },
      calculationUnit: {
        first_names: "first_names",
        last_names: "last_names",
        code: "code",
        email: "email"
      },
      calendarDay: {
        is_laboral: "is_laboral",
        day: "day"
      }
    }
  },
  unknownCalculationUnitCode: "DESCONOCIDO",
  dashboard: {
    connectorsList: [
      'buk',
      'bukc11v1',
      'bukc12v1',
      'bukc63v1',
      'expert',
      'expc04ba',
      'expc04se',
      'sapc16v1',
      'sapc72v1',
      'sapc89v1',
      'winc03v1',
      'winc03re'
    ],
  },
  language: {
    calculationUnitTranslations: {
      CALCULATION_UNIT: "CALCULATION_UNIT",
      CALCULATION_UNIT_CAPITALIZED: "CALCULATION_UNIT_CAPITALIZED",
      CALCULATION_UNIT_PLURAL: "CALCULATION_UNIT_PLURAL",
      CALCULATION_UNIT_PLURAL_CAPITALIZED: "CALCULATION_UNIT_PLURAL_CAPITALIZED",
      CALCULATION_UNIT_WITH_ARTICLE: "CALCULATION_UNIT_WITH_ARTICLE",
      CALCULATION_UNIT_GENDER_VOCAL: "CALCULATION_UNIT_GENDER_VOCAL",
      CALCULATION_UNIT_WITH_ARTICLE_CAPITALIZED: "CALCULATION_UNIT_WITH_ARTICLE_CAPITALIZED",
      CALCULATION_UNIT_OF_PREFIX: "CALCULATION_UNIT_OF_PREFIX",
      CALCULATION_UNIT_UNIT_PREFIX: "CALCULATION_UNIT_UNIT_PREFIX",
    }
  }
};

export default constants;



// WEBPACK FOOTER //
// ./source/definitions/constants.js